/**
 * Linked Excel Editor Agent - Evaluation Section
 * 
 * Section 5: Final reminders and critical rules
 * 
 * Provides final reminders and critical rules.
 * 
 * Keywords AI Key: LINKED_EXCEL_EVALUATION
 */

import { PromptSectionBase } from '../../base/systemPrompt/PromptSectionBase';
import { getSharedVariable } from '../../../prompts';
import { LINKED_EXCEL_PROMPT_KEYS } from './variables';

class LinkedExcelEditorEvaluationSection extends PromptSectionBase {
    protected readonly keywordsKey = LINKED_EXCEL_PROMPT_KEYS.evaluation;
    protected readonly fallbackContent = `## Final Reminders

1. **Read before editing** - Understand the workbook structure
2. **Use natural language plus exact targets** - Tool calls should be explicit and verifiable
3. **Enforce chart safety** - readExcel.readCharts -> editChart -> readExcel.readCharts with readId lineage
4. **Call submitResults when done** - Report completion status

{{securityWarnings}}`;
}

const evaluationSection = new LinkedExcelEditorEvaluationSection();

/**
 * Get the evaluation section.
 * Uses Keywords AI if available, otherwise falls back to code.
 * Supports {{securityWarnings}} variable replacement.
 */
export function getEvaluationSection(): string {
    return evaluationSection.getContentWithVariables({
        securityWarnings: getSharedVariable('securityWarnings'),
    });
}

/**
 * Export constant for backwards compatibility
 */
export const LINKED_EXCEL_EVALUATION = evaluationSection.getFallbackContent();
